import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from 'redux-persist/lib/storage';
import thunk from "redux-thunk";
import book from "./store/BookSlice";
import card from "./store/CardSlice";
import common from "./store/CommonSlice";
import game from "./store/GameSlice";
import menu from "./store/MenuSlice";
import tool from "./store/ToolSlice";
import track from "./store/TrackSlice";
import video from "./store/VideoSlice";

const reducers = combineReducers({
  common : persistReducer({
    key : 'common',
    storage,
    blacklist : ['pop_audio', 'pop_video', 'pop_card', 'fullscreen', 'zoom', 'loading']
  }, common.reducer),
  menu : persistReducer({
    key : 'menu',
    storage,
    blacklist : ['act', 'content_menu', 'unit_menu', 'animation_menu', 'menu', 'content', 'unit', 'animation', 'bookmark']
  }, menu.reducer),
  book : book.reducer,
  track : persistReducer({
    key : 'track',
    storage,
    blacklist : ['unit_act', 'unit', 'track', 'play', 'rewind', 'repeat', 'duration_time', 'current_time', 'range']
  }, track.reducer),
  video : persistReducer({
    key : 'video',
    storage,
    blacklist : ['duration_time', 'current_time', 'video_src', 'play', 'range', 'duration', 'change_time']
  }, video.reducer),
  card : persistReducer({
    key : 'card',
    storage,
    blacklist : ['unit', 'slide', 'word_play']
  }, card.reducer),
  game : persistReducer({
    key : 'game',
    storage,
    blacklist : ['dice', 'dice_act']
  }, game.reducer),
  tool : persistReducer({
    key : 'tool',
    storage,
    blacklist : ['mode', 'tool_act', 'memo_act', 'mask_act', 'clear', 'undo']
  }, tool.reducer)
});

const persistConfig = {
  key : 'root',
  storage,
  blacklist : ['common', 'menu', 'track', 'video', 'card', 'game', 'tool']
};

const persistedReducer = persistReducer(persistConfig, reducers);

export default configureStore({
  reducer : persistedReducer,
  middleware : [thunk]
});